let refreshCart = () => {
    // Refresh drawer cart
    document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
  
    // Refresh cart page if we're on the cart page
    if (window.location.pathname.includes('/cart')) {
        window.location.reload();
    }
  };

let getCart = async () => {
    let cartResponse  = await fetch(Shopify.routes.root+`cart.js`);
    let cart          = await cartResponse.json();
    if (!cart.token) return !!console.error("El carrito no parece correcto", cart);
    return cart;
}

let checkCart = async () => {
    let cart = await getCart();

    var cartGiftCount  = 0;
    var cartIsEligible = cartIsEligibleForGift(cart);
    for( item of cart.items ) { 
        if (await itemIsGift(item)) {
            cartGiftCount += item.quantity
        }
    }

    // Si es cualificable al regalo pero no tiene regalo, le añadimos el regalo
    if (cartGiftCount <= 0 && cartIsEligible) {
        await addGiftToCart(cart.items);
        await refreshCart();
    // Si no es cualificable y tiene regalo, se lo quitamos ya que no se lo merece
    } else if (cartGiftCount >= 1 && !cartIsEligible) {
        if (!await removeGiftFromCart(cart.items)) {
            throw 'Problem substracting quantity';   
        }
        await refreshCart();
    }

    if (cartGiftCount > 1) {
        if (!await removeGiftFromCart(cart.items)) {
            throw 'Problem deleting all quantity';
        }
        await refreshCart();
        checkCart();
    }
}

let getPriceThreshold = () => {
    let priceThreshold = "4999999";
    
    // Remove any whitespace
    priceThreshold = priceThreshold.trim();
    
    // Replace comma as decimal separator with dot
    if (priceThreshold.includes(',') && !priceThreshold.includes('.')) {
        priceThreshold = priceThreshold.replace(',', '.');
    }
    
    // Remove any non-digit characters except the decimal point
    priceThreshold = priceThreshold.replace(/[^\d.]/g, '');
    
    // Parse the cleaned string to a float
    priceThreshold = parseFloat(priceThreshold);
    
    // Check if the result is a valid number
    if (isNaN(priceThreshold)) {
        return false;
    }
    
    return priceThreshold;
}

let cartIsEligibleForGift = (cart) => {
    let priceThreshold = parseInt(getPriceThreshold()) * 100;
    let totalPrice     = cart.total_price

    if (!priceThreshold) {
        return false;
    }
    
    return totalPrice >= priceThreshold;
}


/**
 * 
 * Obtiene el producto de regalo
 * 
 * @returns {Object} Producto de regalo
 */
var cachedGift = undefined;
let getGiftProduct = async () => {

    if (cachedGift) {
        return cachedGift;
    }

    let productHandle = ``.trim();

    if (!productHandle) {
        return;
    }

    let rawResponse  = await fetch(`/products/${productHandle}.json`, {method: "GET"});
    let responseData = await rawResponse.json();
    
    if (!responseData || !responseData.product) {
        return false;
    }

    cachedGift = responseData.product;
    return await getGiftProduct();
};


/**
 * 
 * Nos informará si un item es un regalo o no
 * 
 * @param {Object} item Item del carrito a checkear
 * 
 * @returns {Boolean} Si es un regalo o no
 * 
 */
let itemIsGift = async (item) => {
    let giftProductVariantId = getFirstAvailableVariantId(await getGiftProduct());
    return giftProductVariantId && giftProductVariantId == item.id;
} 


/**
 * 
 * Obtiene la primera variante para el producto
 * 
 * @param {Object} product Datos del producto a obtener la primera varianter
 * 
 * @returns {Number} Identificador de la primera variante disponible del producto
 * 
 */
let getFirstAvailableVariantId = (product) => {
    if (!product || !product.variants) throw 'No variants for the product data!';
    let variant_id = undefined;
    for (variant of product.variants) {
        if (variant.inventory_quantity <= 0) continue;
        variant_id = variant.id;
    }
    return variant_id;
}


/**
 * 
 * Añade el regalo al carrito
 * 
 * @param {Number}   qty      Cantidad de regalo a añadir
 * @param {Boolean}  change   Si mandamos la request como change o como add (change actualiza la cantidad -pero no añade- mientras que add incrementa/añade)
 * 
 * @returns {Promise} Promesa que se resolverá cuando se complete la adición
 * 
 */
let addGiftToCart = async (qty = 1, change = false) => {
    
    let giftProduct = await getGiftProduct();
    if (!giftProduct) {
        return console.error("cart:no-gift-product");
    }
   
    let giftVariantId = getFirstAvailableVariantId(giftProduct);
    if ( !giftVariantId ) return console.error("cart:no-variant-gift-product");
    
    let data = new FormData();
        data.set("id", giftVariantId);
        data.set("quantity", qty);
        
    
    let response = await fetch(`/cart/${change ? `change` : `add`}.js`, {
        method: "POST",
        body: data,
    });

    return (response.status === 200 && response.ok);
}

/**
 * 
 * Quita el regalo del carrito
 * 
 * 
 * @returns {Promise} Promesa que se resuelve cuando se termina de quitar el regalo
 */
let removeGiftFromCart = async (cartItems) => {
    
    for (item of cartItems) {
        if (!await itemIsGift(item)) continue;

        let data = new FormData();
            data.set("id", item.id);
            data.set("quantity", 0);
            
        let response = await fetch(`/cart/change.js`, {
            method: "POST",
            body: data,
        });

        return (response.status === 200 && response.ok);
    }    
}

document.addEventListener("cart:change", checkCart);
document.addEventListener("DOMContentLoaded", checkCart);